import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import defaultColor from './defaultColor';

export default function SalesIcon(props) {
  const color = props.color === 'secondary' ? '#b1b1b1' : props.color;
  return <SvgIcon {...props} viewBox="0 0 14 14" fill="none">
    <path id="Intersect"  stroke={color || defaultColor} fill="none" strokeLinecap="round"
          d="M7 3.35999c-1.66462 0 -3.40467 0 -4.86335 0.25026 -0.69919 0.11996 -1.249995 0.63254 -1.40011 1.299C0.5 5.9594 0.5 6.93896 0.5 8.43s0 2.4706 0.23654 3.5208c0.150115 0.6664 0.70092 1.179 1.40011 1.299C3.59533 13.5 5.33538 13.5 7 13.5c1.66462 0 3.4047 0 4.8633 -0.2502 0.6992 -0.12 1.25 -0.6326 1.4002 -1.299C13.5 10.9006 13.5 9.92104 13.5 8.43s0 -2.4706 -0.2365 -3.52075c-0.1502 -0.66646 -0.701 -1.17904 -1.4002 -1.299C10.4047 3.35999 8.66462 3.35999 7 3.35999Z"
          strokeWidth="1"></path>
    <path id="Vector 194"  stroke={color || defaultColor} fill="none" strokeLinecap="round"
          d="M4.29175 3.39608v-0.72941C4.29175 1.47005 5.30222 0.5 6.54869 0.5h0.90278c1.24648 0 2.25694 0.97005 2.25694 2.16667v0.72941"
          strokeWidth="1"></path>
    <path id="Vector" stroke={color || defaultColor} fill="none" strokeLinecap="round"
          d="M8.31292 6.99869s-0.49355 -0.55018 -1.29406 -0.48142c-0.8005 0.06875 -1.18636 0.56055 -1.18636 1.05371 0 1.43835 2.48042 0.44156 2.48042 1.91653 0 0.76039 -1.64536 1.29719 -2.62566 0.40257m1.4297 -4.34003v0.96127m0 3.83748v0.9612"
          strokeWidth="1"></path>
  </SvgIcon>
}

